import React, { useEffect, useState } from "react";
import { sitename } from "../../constants/constants";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { FiltersCard } from "../../components/Common/FiltersCard";
import { hasPermission } from "../../helpers/helpers";
// import TableLoader from "components/Common/TableLoader";

const Welcome = (props) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [summary, setsummary] = useState([]);
  const [sports, setsports] = useState([]);
  const [pragmatic, setpragmatic] = useState([]);
  const [turbo, setturbo] = useState([]);
  const [bigwins, setbigwins] = useState([]);

  const primaryCallback = (res) => {
    setsummary(res.data.summary);
    setsports(res.data.sports);
    setpragmatic(res.data.pragmatic);
    setturbo(res.data.turbo);
    setbigwins(res.data.bigwins);
  };
  const error = (err) => {
    console.log(err);
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/*<DateRangeCard />*/}
          <Card>
            <CardBody>
              <h3>Welcome {sitename}</h3>
            </CardBody>
          </Card>
          {hasPermission("access-summary") && (
            <div>
              <FiltersCard
                fromDate={fromDate}
                toDate={toDate}
                setToDate={setToDate}
                setFromDate={setFromDate}
                showToDate={true}
                notDisplayFilter={true}
              />
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Welcome;

